import React, { Component } from 'react';
import './styles.css'
import { showConfirm, alertSuccess, alertWarning } from './../../../../services/dialog'
import lang from './../../../../languages/en'
import { updateShipper } from './../../../../utils/shipperInfor'
import handleException from './../../../../services/handleException'
import history from './../../../../services/history'
import { shipperLocalStorage } from './../../helper'

class Row extends Component {
    onClick = (ShipperId) => {
        if(this.props.currentShipper === this.props.shipper_id) {
            history.push("/orders"); return;
        }
        showConfirm(lang.confirm_switch_shipper, () => this.updateShipper(ShipperId))
    }

    updateShipper = (ShipperId) => {
        let data = {
            ShipperId
        }
        this.props.handleLoading(true)
        updateShipper(data).then(res => {
            if(res.data.code === 10001) {
                shipperLocalStorage(this.props.listShipper, ShipperId)
                this.props.handleCurrentShipper(this.props.shipper.ShipperId)
                history.push('/orders')
            } else {
                handleException(res)
            }
            this.props.handleLoading(false)
        }).catch(res => {
            handleException(res)
        })
    }

    render() {
        const { shipper, keyRow } = this.props
        return (
            <tr
                onClick={() => this.onClick(shipper.ShipperId)}
                id='row-switch-shipper'
                className={
                    'item ' +
                    ((keyRow % 2) !== 0 ? 'row-switch-shipper-even' : '') + 
                    (this.props.currentShipper === this.props.shipper_id ? ' shipper-active' : '')
                }
            >
                <td>{shipper.BranchShortNameCH}</td>
                <td>{shipper.ShipperNameCH}</td>
                <td>{shipper.Address1CH + ", " + shipper.Address2CH + ", " + shipper.Address3CH1 + ", " + shipper.Address4CH2}</td>
                <td>{this.props.currentShipper === this.props.shipper_id && 'Yes'}</td>
            </tr>
        );
    }
}

export default Row;


// WEBPACK FOOTER //
// ./src/containers/switch-shipper/components/row/index.js